import React, { useState , useRef} from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../../molecules/navbar";
import Footer from "../../molecules/footer";

import styles from "./dashboard.module.scss";
import { dashboardRoute , employeeDashboardRoute } from "../../../routes/routes";
import SideBar from "../../molecules/sidebar";
import ScrollToTop from "../../../ScrollToTop";
import Sidebar from "../../molecules/sidebar";
import { useCookies } from "react-cookie";

const DashboardLayout = () => {
  const [roleName , setIsRoleName] = useState("");
  const [isExpanded, setIsExpanded] = useState(true);
  const scrollContainerRef = useRef(null);

   const [cookie, setCookie] = useCookies([
      "euid",
      "role",
      "eun",
      "eut",
      "e_t",
      "eid",
      "profile",
    ]);

  return (
    <div className={styles.dashboard}>
      <Sidebar isExpanded={isExpanded} setIsExpanded={setIsExpanded} />
      <div
        className={styles.dashboard_content}
        style={{
          marginLeft: isExpanded ? "256px" : "80px",
          width: isExpanded ? "calc(100vw - 254px)" : "calc(100vw - 80px)",
        }}
      >
        <div className={styles.dashboard_right}>
          <ScrollToTop />
          <Navbar scrollContainerRef={scrollContainerRef}/>
          <main className={styles.main_content} ref={scrollContainerRef}>
            <Outlet />
             {dashboardRoute}
          </main>
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;
